import { lazyFullDensity } from './lazyFullDensity';
import { lazyMediumDensity } from './lazyMediumDensity';
import { lazyCompactDensity } from './lazyCompactDensity';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function getCurrentLazyDensity(selectedDensityMode: string) {
    if (!isFeatureEnabled('mon-densities')) {
        return null;
    }
    return selectedDensityMode === 'Compact'
        ? lazyCompactDensity
        : selectedDensityMode === 'Simple'
        ? lazyMediumDensity
        : lazyFullDensity;
}
